import { render, staticRenderFns } from "./CarItemPOS.vue?vue&type=template&id=902001ca&"
import script from "./CarItemPOS.vue?vue&type=script&lang=js&"
export * from "./CarItemPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports